import React from 'react';
import DeepSEAJobSubmitPage from '../../components/deepsea/DeepSEAJobs/DeepSEAJobSubmitPage';
import DeepSEAJobPage from '../../components/deepsea/DeepSEAJobs/DeepSEAJobPage';
import Layout from '../../components/Layout';

import { TITLE, DEEPSEA_ANALYSES } from '../../settings';

function action({ query, params }) {
  let title = `${TITLE} DeepSEA`;
  let component;

  if (params.id) {
    title = `DeepSEA - ${params.id}`;
    component = (
      <Layout>
        <DeepSEAJobPage {...params} />
      </Layout>
    );
  } else {
    // An analysis that does not exist is a bad URL, not a reason to quietly
    // show a different one -- returning nothing falls through to the
    // catch-all route, which answers 404. An absent or empty value still
    // means "no analysis chosen" and gets the default.
    if (
      query.analysis &&
      !Object.values(DEEPSEA_ANALYSES).includes(query.analysis)
    ) {
      return undefined;
    }
    component = (
      <Layout>
        <DeepSEAJobSubmitPage analysis={query.analysis} />
      </Layout>
    );
  }

  return {
    chunk: ['deepsea'],
    title,
    component,
  };
}

export default action;
